<template>
  <div class="caefa-footer">
    <div id="fd">
      <p>
        登记管理机关：中华人民共和国民政部     主管单位：中央社会工作部
      </p>
      <p>Copyright 2013-2025 中国民族民间工艺美术家协会 ©版权所有</p>
      <p><a href="http://beian.miit.gov.cn/">京ICP备13028664号</a></p>
    </div>
    <div class="h20"></div>
    <div id="bottom"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.caefa-footer {
  #fd {
    border-top: 1px solid #b9b9b9;
    margin-top: 20px;
    height: 63px;
    padding-top: 10px;
    padding-bottom: 10px;
    line-height: 20px;
    color: #000;
    text-align: center;
  }
  .h20 {
    height: 20px;
  }
  #bottom {
    background: url(../assets/images/bottom_bg.jpg) left top repeat-x;
    height: 62px;
  }
}
</style>